import { Link } from "react-router-dom";

export default function NotFoundPage() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-background-50 px-4 text-center">
      <span className="flex h-16 w-16 items-center justify-center rounded-2xl bg-background-100 text-foreground-400">
        <i className="ri-compass-3-line text-3xl" />
      </span>
      <h1 className="mt-6 text-5xl font-bold text-foreground-950">404</h1>
      <p className="mt-2 text-base font-medium text-foreground-900">Page not found</p>
      <p className="mt-1 max-w-sm text-sm text-foreground-500">
        The page you're looking for doesn't exist or may have been moved.
      </p>
      <Link
        to="/"
        className="mt-6 inline-flex h-9 items-center gap-2 rounded-md bg-primary-500 px-4 text-sm font-medium text-white hover:bg-primary-600"
      >
        <i className="ri-arrow-left-line" /> Back to dashboard
      </Link>
    </div>
  );
}